import { Component, Input, OnInit } from '@angular/core';
import { PnInputControlConfiguration } from './pn-input-control.configuration';

@Component({
  selector: 'pn-input-control',
  templateUrl: './pn-input-control.component.html',
  styleUrls: ['./pn-input-control.component.scss']
})
export class PnInputControlComponent implements OnInit {

  @Input() configuration : PnInputControlConfiguration | null = null

  constructor() { }

  ngOnInit() {
  }

}
